export enum PackageV1PrestationType {
  HOTEL = 'HOTEL',
  TRANSPORT = 'TRANSPORT',
  TRANSFERT = 'TRANSFERT',
  CAR_RENTAL = 'CAR_RENTAL',
  OPTION = 'OPTION',
}
